<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5475 5.00373L10.3506 4.38782L8.47444 0.547114C8.4232 0.441958 8.3389 0.356832 8.23476 0.305088C7.97359 0.174895 7.65621 0.283389 7.52563 0.547114L5.64949 4.38782L1.45256 5.00373C1.33685 5.02043 1.23106 5.07551 1.15007 5.15897C1.05215 5.26059 0.998187 5.39732 1.00005 5.5391C1.00191 5.68088 1.05943 5.81611 1.15998 5.91509L4.19652 8.90453L3.47912 13.1258C3.4623 13.224 3.47306 13.325 3.51018 13.4173C3.54731 13.5097 3.60931 13.5896 3.68916 13.6482C3.76901 13.7068 3.86352 13.7416 3.96196 13.7486C4.0604 13.7557 4.15883 13.7348 4.24611 13.6883L8.00003 11.6953L11.754 13.6883C11.8564 13.7434 11.9755 13.7617 12.0895 13.7417C12.3771 13.6916 12.5705 13.4162 12.5209 13.1258L11.8036 8.90453L14.8401 5.91509C14.9227 5.8333 14.9773 5.72647 14.9938 5.60963C15.0384 5.31753 14.8368 5.04713 14.5475 5.00373Z"
      fill="currentColor"
    />
  </svg>
</template>
